module.exports = __webpack_public_path__ + "img/purpleDunes.66df4671.svg";